import {Observable, Subject} from "rxjs";

/*interface Page {
   topThreshold: number,
   bottomThreshold: number
}*/

/*
export interface StartScrollEvent {
   startY: number;
   startTime: number;
}
*/

/*export interface StopScrollEvent {
   startY: number;
   startTime: number;
   endY: number
   endTime: number;
   movedDown: boolean;
   distance: number;
   speed: number;
}*/

export class ConcatScroll {

   scrollStartSubject = new Subject<any>();
   scrollStopSubject = new Subject<any>();
   public scrollStart$: Observable<any> =
      this.scrollStartSubject.asObservable();
   public scrollStop$: Observable<any> =
      this.scrollStopSubject.asObservable();
   //private lastScrollms = 0;
   private timer;
   private readonly threshold;

   // private start: StartScrollEvent;
   private ignoreNext = false;
   private stopped = true;

   constructor(threshold: number = 100) {
      this.threshold = threshold;
      this.init()
   }

   init() {
      window.addEventListener(
         'scroll', this.onScroll.bind(this), {passive: true});
   }

   /*getDocumentScroll() {
      //console.log('getDocumentScroll');
      return document.documentElement.scrollTop || window.pageYOffset
   }*/

   onScroll() {
      let now = Date.now();
      // let elapsed = now - this.lastScrollms;
      // console.log('elapsed', elapsed);
     /* if(this.getDocumentScroll() < 0){
         //ignore safari bounce
         return;
      }*/

      if(this.stopped){
         //this.start = {
         //   startTime: now,
         //   startY: this.getDocumentScroll()
         //};
         this.scrollStartSubject.next(true);
         this.stopped = false;
      } else {
         if(this.timer){
            clearTimeout(this.timer)
         }
      }


     /* if ( elapsed < this.threshold) {
         if (this.timer) {
            clearTimeout(this.timer);
         }
      } else if (elapsed > this.threshold) {
         this.start = {
            startTime: now,
            startY: this.getDocumentScroll()
         }
         if(!this.ignoreNext){
            this.scrollStartSubject.next(this.start);
         }

      }*/
      this.timer = setTimeout(() => {
         // let top = this.getDocumentScroll();
         //let wasIgnoring = this.ignoreNext;
         //this.ignoreNext = false;
         this.stopped = true;
         this.scrollStopSubject.next(
             false
            /*Object.assign({
               endY: top,
               endTime: now,
               movedDown: top > this.start.startY,
               distance: Math.abs(this.start.startY - top),
               speed: Math.abs(this.start.startY - top)/(now - this.start.startTime)
            }, this.start)*/
         );
        /* if(!wasIgnoring){
            this.scrollStopSubject.next(
               Object.assign({
                  endY: top,
                  endTime: now,
                  movedDown: top > this.start.startY,
                  distance: Math.abs(this.start.startY - top),
                  speed: Math.abs(this.start.startY - top)/(now - this.start.startTime)
               }, this.start)
            );
         }*/

      }, this.threshold);
      // this.lastScrollms = now;

   }


}